import React,{ useState} from 'react';
import Footer from '../components/global-components/Footer';
import Layouts from '../components/global-components/Layouts';
import HeaderV3 from '../components/section-components/Header-v3';
import TeamExecutiveBoard from '../components/section-components/TeamExecutiveBoard';
import { baseUrl } from '../data/config.json';
import axios from "axios";

const TeamPageExecutiveBoard = () => {

    const [banner, setBanner] = useState("");

    try {
        axios.get(baseUrl + "/banner/single.php?pageId=banner_team").then((response) => {
            if (response && response.data && response.data.valor && banner !== response.data.valor) {
                setBanner(response.data.valor)
            }
        });
    } catch (error) {
        console.error(error);
    }


    return (
        <>
            <Layouts  pageTitle='People'>
                <HeaderV3 title={"People"} pageName={"People"}  />
                <TeamExecutiveBoard />
                <Footer />
            </Layouts>
        </>
    );
}

export default TeamPageExecutiveBoard;